<template>
  <div
    class="szw-flex szw-flex-col szw-rounded-2 szw-border szw-border-solid szw-border-border szw-items-center szw-select-none szw-bg-background-color-secondary"
    :class="isMobileView ? 'szw-w-[148px] szw-h-[66px] szw-p-1 szw-gap-[2px]' : 'szw-w-[200px] szw-h-[76px] szw-py-1 szw-px-2'"
  >
    <div class="szw-flex szw-h-3 szw-text-xxs szw-justify-center szw-items-center" :class="isMobileView ? 'szw-gap-[6px]  szw-w-[132px]' : 'szw-gap-[10px]  szw-w-[180px]'">
      <div class="szw-bg-text-icon-label szw-h-px szw-flex-grow"></div>
      <div
        class="szw-font-semibold szw-uppercase szw-text-text-icon-label szw-tracking-[0.4px] szw-truncate szw-text-center szw-w-fit"
        :class="isMobileView ? 'szw-max-w-[80px]' : 'szw-max-w-[120px]'"
      >
        {{ competition }}
      </div>
      <div class="szw-bg-text-icon-label szw-h-px szw-flex-grow"></div>
    </div>
    <div class="szw-flex szw-flex-row szw-justify-between szw-items-center" :class="isMobileView ? 'szw-w-[140px]' : 'szw-w-[182px]'">
      <div
        class="szw-flex szw-flex-col szw-h-full szw-w-[40px] szw-justify-center szw-items-center"
        :class="isMobileView ? 'szw-px-[2px] szw-gap-[2px]' : 'szw-px-1 szw-gap-[2px]'"
      >
        <img v-if="teams.home.logo" draggable="false" :class="isMobileView ? 'szw-h-[20px] szw-w-[20px]' : 'szw-h-[32px] szw-w-[32px]'" :src="teams.home.logo.small" alt="logo" />
        <fallback-logo
          v-else
          :text="teams.home.abbreviation"
          :class="isMobileView ? 'szw-h-[20px] szw-w-[20px] szw-leading-[20px] szw-text-[10px]' : 'szw-h-[30px] szw-w-[30px] szw-leading-[30px]'"
        />
        <span class="szw-text-xs" :class="isMobileView ? 'szw-font-light' : 'szw-font-normal'">{{ getName(teams.home) }}</span>
      </div>
      <div class="szw-flex szw-flex-col szw-h-full szw-font-semibold" :class="isMobileView ? 'szw-w-[56px]  szw-gap-[2px]' : 'szw-w-[102px] szw-gap-1'">
        <div
          class="szw-flex szw-w-full szw-justify-center szw-items-center"
          :class="[isMobileView ? 'szw-h-[20px] szw-text-xs szw-pt-[2px]' : 'szw-h-[30px] szw-text-2xl szw-pt-1', { 'szw-text-color-primary': activeTheme === 'mozzart' }]"
        >
          <template v-if="statusInfo.live || statusInfo.event === 'closed' || statusInfo.event === 'ended'">
            <div>{{ teams.home.result.score }}</div>
            <div>:</div>
            <div>{{ teams.away.result.score }}</div>
          </template>
          <template v-else-if="!statusInfo.live && !statusInfo.status">
            <div class="szw-flex szw-text-text-icon-primary" :class="isMobileView ? 'szw-text-xs' : 'szw-text-sm'">{{ statusInfo.upcoming.time }}</div>
          </template>
          <template v-else>
            <div class="szw-flex szw-text-text-icon-primary" :class="isMobileView ? 'szw-text-xs' : 'szw-text-sm'">{{ statusInfo.upcoming.time }}</div>
          </template>
        </div>
        <div v-if="statusInfo.live" class="szw-w-full szw-flex szw-justify-center szw-text-xxs szw-uppercase szw-items-center">
          <div
            :class="[
              sportType === 'football' ? 'szw-bg-sport-color-soccer' : 'szw-bg-sport-color-basketball',
              isMobileView ? 'szw-h-[16px] szw-w-[56px] szw-shining-container' : 'szw-h-[20px]',
              'szw-px-1 szw-flex szw-justify-center szw-items-center szw-rounded-1 szw-text-text-icon-secondary'
            ]"
          >
            <sprite sprite-id="live-indicator" class="szw-h-3 szw-w-3" :color="activeTheme === 'mozzart' ? 'var(--szw-color-primary)' : '#ffffff'" />
            <span v-if="!isMobileView" class="szw-pl-1 szw-tracking-[0.4px] szw-truncate szw-max-w-10">{{ loc('sm_live', langId) }}</span>
          </div>
        </div>
        <div
          v-if="statusInfo.upcoming.isUpcoming"
          :class="[
            'szw-flex szw-justify-center szw-text-xxs szw-leading-xxs szw-uppercase szw-items-center szw-px-1 szw-rounded-1 szw-min-w-14 szw-w-fit szw-mx-auto',
            isMobileView ? 'szw-h-[16px]' : 'szw-h-[20px]',
            { 'szw-bg-section-static': !['mozzart', 'soccer-bet'].includes(activeTheme) },
            { 'szw-bg-color-primary szw-text-color-secondary': activeTheme === 'mozzart' },
            { 'szw-bg-ls-upcoming szw-text-color-primary': activeTheme === 'soccer-bet' }
          ]"
        >
          <span>{{ statusInfo.upcoming.date }}</span>
        </div>
        <div
          v-if="!statusInfo.live && !statusInfo.upcoming.isUpcoming && statusInfo.status"
          class="szw-w-full szw-flex szw-justify-center szw-uppercase szw-items-center szw-bg-section-static szw-font-semibold szw-rounded-1 szw-max-w-14 szw-self-center szw-gap-1"
          :class="isMobileView ? 'szw-h-[16px]' : 'szw-h-[20px]'"
        >
          <sprite sprite-id="full-time-clock" />
          <div class="szw-flex szw-justify-center szw-items-center szw-text-xxs szw-truncate szw-leading-[12px]" :class="isMobileView ? 'szw-h-[16px]' : 'szw-h-[20px]'">
            {{ statusInfo.status }}
          </div>
        </div>
        <div
          v-if="!statusInfo.live && !statusInfo.upcoming.isUpcoming && !statusInfo.status"
          :class="[
            'szw-flex szw-justify-center szw-text-xxs szw-leading-xxs szw-uppercase szw-items-center szw-px-1 szw-rounded-1 szw-min-w-14 szw-w-fit szw-mx-auto',
            isMobileView ? 'szw-h-[16px]' : 'szw-h-[20px]',
            activeTheme !== 'mozzart' ? 'szw-bg-section-static' : 'szw-bg-color-primary szw-text-color-secondary'
          ]"
        >
          <span>{{ statusInfo.upcoming.date }}</span>
        </div>
      </div>
      <div
        class="szw-flex szw-flex-col szw-h-full szw-w-[40px] szw-justify-center szw-items-center"
        :class="isMobileView ? 'szw-px-[2px] szw-gap-[2px]' : 'szw-px-1 szw-gap-[2px]'"
      >
        <img v-if="teams.away.logo" draggable="false" :class="isMobileView ? 'szw-h-[20px] szw-w-[20px]' : 'szw-h-[32px] szw-w-[32px]'" :src="teams.away.logo.small" alt="logo" />
        <fallback-logo
          v-else
          :text="teams.away.abbreviation"
          :class="isMobileView ? 'szw-h-[20px] szw-w-[20px] szw-leading-[20px] szw-text-[10px]' : 'szw-h-[30px] szw-w-[30px] szw-leading-[30px]'"
        />
        <span class="szw-text-xs" :class="isMobileView ? 'szw-font-light' : 'szw-font-normal'">{{ getName(teams.away) }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import FallbackLogo from '@/__core__/components/FallbackLogo.vue'
import { loc } from '@/__core__/localization/localization'
import Sprite from '@/__core__/components/sprite/Sprite.vue'
import { inject, computed } from 'vue'
import { mapSportRadarTeamNameToCustomNames } from '@/widgets/standings/StandingsWidget.constants'

const props = defineProps({
  event: {
    type: Object,
    default: () => ({
      startTime: String
    })
  },
  statusInfo: {
    type: Object,
    default: () => {}
  },
  isMobileView: {
    type: Boolean,
    default: false
  },
  sportType: {
    type: String,
    default: ''
  },
  competition: {
    type: String,
    default: '-'
  }
})

const langId = inject('langId', '')
const activeTheme = inject('activeTheme', '')

const teams = computed(() => {
  const result = { home: null, away: null }

  props.event.competitors.forEach(competitor => {
    if (competitor.qualifier === 'home') {
      result.home = competitor
    } else if (competitor.qualifier === 'away') {
      result.away = competitor
    }
  })

  return result
})

const getName = team => {
  const { name, abbreviation } = team
  return mapSportRadarTeamNameToCustomNames[name]?.shortName || abbreviation
}
</script>

<style scoped>
.szw-shining-container {
  position: relative;
  overflow: hidden; /* Ensure the overlay stays within the container */
}

.szw-shining-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: -8%; /* Start from the left outside of the container */
  width: 12px;
  height: 100%;
  background: rgba(255, 250, 248);
  transform: skewX(-25deg); /* Adjust the angle for a diagonal effect */
  animation: shine 2s ease-in-out infinite; /* Duration is 2seconds including the pause, infinite loop */
}

@keyframes shine {
  0% {
    left: -8%;
    opacity: 0.1;
  }
  6% {
    opacity: 0.3;
  }
  12% {
    opacity: 0.6;
  }
  25% {
    left: 120%; /* Slide to the right */
    opacity: 0.6;
  }
  36% {
    opacity: 0.6;
  }
  44% {
    opacity: 0.3;
  }
  50% {
    left: -8%; /* Slide back to the left */
    opacity: 0.1;
  }

  100% {
    left: -8%; /* Pause for the rest of the duration */
    opacity: 0.1;
  }
}
</style>
